import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../shared/components/Button';
import './style.scss';

interface Props {
  isSubmitting: boolean;
  buttonRef: React.RefObject<HTMLButtonElement>;
}

const StickyConfirmRegistrationButton: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const { isSubmitting, buttonRef } = props;

  const [isButtonVisible, setIsButtonVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
      const [entry] = entries;
      setIsButtonVisible(entry.isIntersecting);
    }, { root: null, rootMargin: '0px', threshold: 0 });

    if (buttonRef.current) observer.observe(buttonRef.current);
    return () => {
      if (buttonRef.current) observer.unobserve(buttonRef.current);
    };
  }, []);

  return (
    <>
      {!isButtonVisible && (
      <div className="form-item StickyConfirmRegistrationButton">
        <div className="container">
          <div className="u-indent--large">
            <Button
              type="primary"
              variation="center"
              htmlType="submit"
              isLoading={isSubmitting}
            >
              {t('registration_desk.screens.confirm.submit')}
            </Button>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default StickyConfirmRegistrationButton;
